export default {"src":"/_next/static/media/1Hive.22d4ad8a.svg","height":144,"width":200,"blurWidth":0,"blurHeight":0};